import React from 'react';
import { Check, Clock, Bell } from 'lucide-react';
import { StockStatus, stockLabel } from '../data/products';
interface StockBadgeProps {
  status: StockStatus;
  size?: 'sm' | 'md';
}
export function StockBadge({
  status,
  size = 'sm'
}: StockBadgeProps) {
  const config = {
    'in-stock': {
      icon: Check,
      bg: 'bg-green-50',
      text: 'text-green-700',
      ring: 'ring-green-200'
    },
    'pre-order': {
      icon: Clock,
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      ring: 'ring-amber-200'
    },
    notify: {
      icon: Bell,
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      ring: 'ring-gray-200'
    }
  };
  const {
    icon: Icon,
    bg,
    text,
    ring
  } = config[status];
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1.5';
  return <span className={`inline-flex items-center gap-1.5 font-semibold rounded-full ring-1 ring-inset ${bg} ${text} ${ring} ${sizeClasses}`} data-id="element-198">
      <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} data-id="element-199" />
      {stockLabel(status)}
    </span>;
}